import {HitUtils} from '@hit/components/src/utils/hit/HitUtils';
import {StorageService} from '@hit/base/src/api/data/StorageService';

export class CustomCodeUtils extends HitUtils {
  constructor(parentComponent, router) {
    super();
    this.parentComponent = parentComponent;
    this.router = router;
  }

  buildIframeSrc(file, extraQueryParams = {}) {
    let src = StorageService.getImageUrl(file);
    Object.entries(extraQueryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        src += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    });
    return src;
  }

  openCustomIframe({file, type, label, extraQueryParams = {}}) {
    const src = this.buildIframeSrc(file, extraQueryParams);
    switch (type) {
      case 'iframe':
        this.parentComponent.$data.iframeData = {
          src,
          type: 'top',
          title: label,
        };
        break;
      case 'popup':
        this.parentComponent.$data.iframeData = {
          src,
          type: 'popup',
          title: label,
        };
        break;
      default:
        window.open(
          this.router.resolve({
            name: 'iframe',
            query: {
              src: `${src}&customButton=true`,
            },
          }).href,
          '_blank'
        );
        break;
    }
  }

  executeCustomCode(customUi, action) {
    const data = customUi.find((button) => `custom_${button.id}` === action.id);
    this.openCustomIframe({
      file: data.file,
      type: data.type,
      label: data.label,
    });
  }

  executeActionOverride(override, action) {
    const mode = override.mode || 'preHook';
    this.openCustomIframe({
      file: override.file,
      type: override.type,
      label: override.label || action.label,
      extraQueryParams: {
        overrideActionId: action.id,
        overrideMode: mode,
      },
    });
  }
}
